module.exports = __webpack_public_path__ + "img/header.cea922c2.jpg";